module.exports = __webpack_public_path__ + "static/img/pprocess2.53dcd4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newdownload/pprocess2.png
// module id = 6AAk
// module chunks = 0